export default {
    // "http": 'http://192.168.2.122:8077/web',
    // "http_zhi": "http://192.168.2.110:8092",
    // "http": "http://test.api.hzxwwl.com/api",
    // "http": "http://114.115.183.69:9097",
    "http": "http://admin.houqinbao.com",
    // "http":"http://testapi.houqinbao.com",
}